import di from 'di'
import { keyBy } from 'lodash';

import FindShow from '@/gql/query/FindShow.gql'

export enum PlayerStoreAction {
    FETCH_SHOW = 'FETCH_SHOW'
}

export enum PlayerStoreMutation {
    SET_SHOWS = 'SET_SHOWS',
    ADD_SHOW = 'ADD_SHOW'
}

export const playerStore = {

    state(){

        return {
            showsById: []
        }
    },

    mutations: {

        [PlayerStoreMutation.SET_SHOWS] (state, shows){

            state.showsById = keyBy(shows, 'id');
        },

        [PlayerStoreMutation.ADD_SHOW] (state, show){

            state.showsById[show.id] = show;
        }
    },

    actions: {

        async [PlayerStoreAction.FETCH_SHOW] (ctx, id){

            const apollo = di.get('apollo');
            const results = await apollo.query({
                query: FindShow,
                variables: { id },
                fetchPolicy: 'network-only'
            });

            const show = results.data?.findPresentationShow;

            if(!show){
                throw 'Invalid response'
            }

            ctx.commit(PlayerStoreMutation.ADD_SHOW, show);
        }
    }
}